import React from 'react';
import { connect } from 'react-redux';
import {Route , Link} from 'react-router-dom';
import { Navbar , Footer } from '../../_components';
import { ExchangePage } from '../ExchangePage';
import { DepositPage } from '../DepositPage';
import { ProfilePage } from '../ProfilePage';
import { WithdrawPage } from '../WithdrawPage';
import {  GetHWGCashPage , RedeemHWGCashPage  } from '../HWGCashPage';
import { WalletPage } from '../WalletPage';
import { walletAction } from '../../_actions';
import { OrdersPage } from '../OrdersPage';

class AccountPage extends React.Component{

    componentDidMount(){
        //get user wallet on account page load 
        this.props.dispatch(walletAction.getMemberWallet());
    }

    render(){
        return (
            <div>
               <Navbar />
                    <Route path ="/account/deposit"  component= { DepositPage } />
                    <Route path ="/account/profile"  component= { ProfilePage } />
                    <Route path="/account/gethwgcash" component={ GetHWGCashPage }/>
                    <Route path="/account/redeemhwgcash" component={ RedeemHWGCashPage }/>
                    <Route path="/account/wallet" component={ WalletPage }/>
                <Footer/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { wallet  } = state;
    return {
        wallet 
    };
}

const connected = connect(mapStateToProps)(AccountPage);
export { connected as AccountPage }; 



// WEBPACK FOOTER //
// ./src/Views/AccountPage/AccountPage.jsx